import { type FC } from "react";
import { MembersList } from "@/components/settings/organization/members/MembersList";
import { useMembers } from "@/queries/organization-queries";
import { useMembership } from "@/hooks/use-membership";
import { useAuthenticatedUser } from "@/queries/user-queries";

export const MembersTab: FC = () => {
    const { data: members } = useMembers();
    const { data: user } = useAuthenticatedUser();
    const { membership } = useMembership();

    return (
        <MembersList
            user={user}
            membership={membership}
            data={{
                members: members?.members || [],
            }}
        />
    );
};
